module.exports = __webpack_public_path__ + "static/media/groomingPageAnalIcon.68ea5881.png";